import { kk, ru } from 'date-fns/locale'
import { i18n } from 'i18next'

export default function getDateFnsLocale (i18n: i18n) {
  const { language } = i18n

  switch (language) {
  case 'kk':
    return kk

  default:
    return ru
  }
}
